import { DecimalText, type DecimalTextProps } from 'components/text/decimal/DecimalText';

export function CurrencyText(props: DecimalTextProps) {
    return <DecimalText {...props} prefix="R$" />;
}
